"use strict";

exports.__esModule = true;
exports.visuallyHiddenStyles = void 0;

const visuallyHiddenStyles = () => ({
  border: 'none',
  clip: 'rect(0px, 0px, 0px, 0px)',
  height: 1,
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: 1
});

exports.visuallyHiddenStyles = visuallyHiddenStyles;